import {NiInput, NiButton} from "@/ni-ui"
import * as API from "@/api/index.js"

export default {
  name: "project-select",
  components:{
    NiInput,
    NiButton,
  },

  model:{
    prop:"project_code",
    event:"change",
  },

  props:{
          value_field:{
            type: String,
            default: "project_code",
          },

          project_code:{
            type:String,
            default:"",
          },
        disable_omnis_project:{   // 为true时云端项目（全部）设置为盛博汇项目
          type:Boolean,
          default:false,
        },

        project_select_disabled:{   // 直接禁用选择，true: 禁用；权重大于 disabled_by_default
          type:Boolean,
          default: null,
        },

        no_default: {
            type:Boolean,
            default:false,
        },

        req_param: {
          type: Object,
          default: function () {
            return {
                  "service": "project_manage.project",
                  "disable_omnis_project": false
                }
          }
        },

        dark:{
            type:Boolean,
            default:false,
        },

        select_style:{
            type: Object,
          default: function () {
            return {
              width: '170px',
            }
          }
        },

        disabled_by_default:{    // 灵活禁用选择。值为true表示禁用（ 但当project_code为‘ALL’，或者disable_omnis_project为true且project_code为‘CBH’时，不禁用）
            type:Boolean,
            default:true,
        },

        no_all_selection: {
            type:Boolean,
            default:false,
        },

        data_url:{
            type: String,
            default: "/omnis/template_data/data",   // 源数据接口路由
        },

        req_method: {    // 源数据请求方法
            type: String,
            default: "POST",
        },

        default_field: {    // 默认项目的对应字段
            type: String,
            default: "default_project",
        },

        with_authority: {    // 是否进行权限控制 ， true：是
            type:Boolean,
            default:true,
        },

      },


  data(){
    return{
      project_options:[],
      current_project_code: "",
      project_loading: false,
      current_project:{},
      project_dict:{},
      select_disabled: false,    // 选择器禁用/可用
      default_project: null,

      cbh_project_code: 'CBH',
      all_project_code: 'ALL',


    }
  },

  created(){

  },


  mounted(){
    this.get_projects()

  },

  watch:{
          project_code(val){
            this.current_project_code = val
          },

          current_project_code(val){
            this.$emit("change", val)
          },

        'current_project':{
            handler(data){
              this.$emit("project_change", data)
            },
          deep:true,
        },


  },

  computed:{
    popper_class(){
      return this.dark ? 'is-dark' : '';
    },

  },

  methods: {

          set_current_row(code){

            if(code){
              let current = this.project_options.find(item => item[this.value_field] === code);
              if (current){
                this.current_project = current;
              }else {
                this.current_project[this.value_field] = code
              }

              this.current_project_code = code

            }

          },

        project_change(val){
            this.current_project = this.project_dict[val]

        },

        async get_projects() {
          let param = Object.assign({}, this.req_param)
          if (this.disable_omnis_project){
            param.disable_omnis_project = this.disable_omnis_project
          }
          if (this.with_authority){
            param.with_authority = '1'
          }else {
            param.with_authority = '0'
          }
          this.project_loading = true
          const response = await API[this.req_method](this.data_url, param)
          this.project_loading = false
          let data = response.data
          if (data.success) {
            this.project_options = data.data
            if (this.no_all_selection){
              this.project_options = this.project_options.filter(item => item.project_code != this.all_project_code)
            }
            this.project_dict = this.array2dict(this.project_options, this.value_field)

            this.default_project = this.project_options.find(item => item[this.default_field] == "true");

            if(this.project_code){
              this.set_current_row(this.project_code)
            }else {
              if (!this.no_default && this.default_project ){
                this.current_project_code = this.default_project[this.value_field]
                this.current_project = this.default_project
              }
            }

            this.set_select_disabled();

          }

        },

        set_select_disabled(){
            if (this.project_select_disabled != null){
              this.select_disabled = this.project_select_disabled
            }else if (this.disabled_by_default){
              if((this.disable_omnis_project && this.current_project.project_code == this.cbh_project_code) || this.current_project.project_code == this.all_project_code){
                this.select_disabled = false
              }else if (!this.default_project){
                this.select_disabled = false
              }else {
                this.select_disabled = true
              }
            }
        },


        set_default_val(){
            if (this.default_project){
              this.set_current_row(this.default_project[this.value_field])
            }
        },
  }


}



// WEBPACK FOOTER //
// ./src/omnis-business/project-select/project-select.js